interface LayerCubeSortParams {
    orderFieldTypeId: number,
    orderMode: number
}

function makeSortParams(actionType: string): LayerCubeSortParams {
    let result: LayerCubeSortParams = {
        orderFieldTypeId: 0,
        orderMode: 0
    };

    if (actionType === 'sortBySalesUp' || actionType === 'sortBySalesDown') {
        result.orderFieldTypeId = 1;
    }

    if (actionType === 'sortByBrandUp' || actionType === 'sortByBrandDown') {
        result.orderFieldTypeId = 2;
    }

    if (actionType === 'sortByTypeUp' || actionType === 'sortByTypeDown') {
        result.orderFieldTypeId = 3;
    }

    if (actionType === 'sortBySalesUp'
        || actionType === 'sortByBrandUp'
        || actionType === 'sortByTypeUp') {
        result.orderMode = 0;
    }

    if (actionType === 'sortBySalesDown'
        || actionType === 'sortByBrandDown'
        || actionType === 'sortByTypeDown') {
        result.orderMode = 1;
    }

    return result;
}

export {
    makeSortParams
};
